<template>
  <div class="APIHomepage_more_detail">
    <div class="more-table-in">
      <div class="detail-breadcrumb">
        <span>
          {{ categoryName }}/
          <span class="fromitem">{{ apiName }}</span>
        </span>
        <span  class="starStyle" @click="isAddCartItemsClick()">
            <img
              src="../../../assets/images/dataServices/dataapi-img/star-on.svg"
              alt=""
              v-if="apiInfo.cart==1"
            />
            <img
              src="../../../assets/images/dataServices/dataapi-img/star-off.svg"
              alt=""
              v-else
            />
          </span>
      </div>
      <div class="more-info-block">
        <div class="info-title">
          <span class="width200">Basic Information</span>
          <div class="api-tag">
            <el-tag
              v-for="(i, idx) in apiInfo.apiDataApiLabel"
              :key="idx"
              :class="'COLOR_' + i.labelColor"
            >
              {{ i.labelName }}
            </el-tag>
          </div>
        </div>
        <div class="info-content">
          <div class="info-list-flex">
            <div class="info-list-title">API ID:</div>
            <div class="info-list-desc">{{ apiInfo.apiDataApiId || "--" }}</div>
          </div>
          <div class="info-list-flex">
            <div class="info-list-title">Call Success Rate:</div>
            <div class="info-list-desc">
              {{ successRationStr || "--%" }}
            </div>
          </div>
          <div class="info-list-flex">
            <div class="info-list-title">Update Time:</div>
            <div class="info-list-desc">
              {{
                $formatDateTime(apiInfo.updateTime, "yyyy-MM-dd hh:mm:ss") ||
                "--"
              }}
            </div>
          </div>
        </div>
      </div>
      <div class="more-info-block">
        <div class="info-title">Technical Information</div>
        <div class="info-content">
          <div class="info-list-flex">
            <div class="info-list-title">API Endpoint:</div>
            <div class="info-list-desc">{{ apiInfo.apiUrl || "--" }}</div>
          </div>
          <div class="info-list-flex">
            <div class="info-list-title">Request Method:</div>
            <div class="info-list-desc">
              {{ apiInfo.requestMethod || "--" }}
            </div>
          </div>
          <div class="info-list-flex">
            <div class="info-list-title">Request Parameters:</div>
          </div>
          <div class="info-content">
            <div class="info-desc"></div>
            <div class="bulkData-completed-table">
              <el-table
                ref="multipleTable"
                :data="requestParamsData"
                tooltip-effect="dark"
                style="width: 100%"
              >
                <el-table-column
                  prop="filedName"
                  label="Filed"
                  width="250"
                ></el-table-column>
                <el-table-column prop="filedType" label="Type" width="200">
                </el-table-column>
                <el-table-column
                  prop="required"
                  label="Required"
                  width="200"
                  show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                  prop="example"
                  label="Example"
                ></el-table-column>
                <el-table-column prop="note" label="Note"></el-table-column>
              </el-table>
            </div>
          </div>
          <div class="info-list-flex">
            <div class="info-list-title fontsize18">RequestBody:</div>
          </div>
          <div class="info-list-desc-content fontsize18">
            <pre>{{ formattedJson(apiInfo.requestBody) }}</pre>
          </div>
          <div class="info-list-flex">
            <div class="info-list-title fontsize18">Return Parameter:</div>
          </div>
          <div class="info-list-desc-content fontsize18">
            <pre>{{ formattedJson(apiInfo.responseBody) }}</pre>
          </div>
        </div>
      </div>
      <div class="more-info-block">
        <div class="info-title">Status Code Description</div>
        <div class="info-content">
          <div class="info-list-flex">
            <div class="info-list-title">true</div>
            <div class="info-list-desc">Success</div>
          </div>
          <div class="info-list-flex">
            <div class="info-list-title">false</div>
            <div class="info-list-desc">Failed</div>
          </div>
        </div>
      </div>
      <div class="more-info-block">
        <div class="info-title">Example Code (Java)</div>
        <div class="info-content">
          <div class="info-list-flex">
            <div class="info-list-title fontsize18">
              Production use only (Java):
            </div>
          </div>
          <div class="info-list-desc-content fontsize18">
            <!-- <pre>{{ formattedJson(apiInfo.javaExampleCode) }}</pre> -->
            <pre>{{ apiInfo.javaExampleCode || "null" }}</pre>
          </div>
        </div>
      </div>
      <div class="more-info-block">
        <div class="info-title">Development Resources</div>
        <div class="info-content">
          <div class="info-list-flex">
            <div class="info-list-title linkCss" @click="downloadClick('pdf')">
              Download API Doc(PDF)
            </div>
          </div>
          <div class="info-list-flex">
            <div class="info-list-title linkCss" @click="downloadClick('word')">
              Download API Doc(Word)
            </div>
          </div>
          <div class="info-list-flex">
            <div class="info-list-title linkCss" @click="downloadClick('enum')">
              Value Dictionary
            </div>
          </div>
        </div>
      </div>
      <div class="btn-box">
        <el-button @click="applyforTest()" class="applyAccountBtn"
          >Request Access</el-button
        >
        <!-- <el-button type="primary" @click="centerDialogVisible = false"
          >Subscription</el-button
        > -->
      </div>
    </div>
    <!-- 申请测试 -->
    <ApplyForTestDialogVue
      :applyDialogVisible="applyDialogVisible"
      :applyfortestForm="applyfortestForm"
      :apiApplyforTestList="apiApplyforTestList"
      @getAPPKey="getAPPKey"
      @getSecretKey="getSecretKey"
      @closeApplyforTestVisible="closeApplyforTestVisible"
      @toGenerateClick="toGenerateClick"
    ></ApplyForTestDialogVue>
  </div>
</template>

<script>
import {
  getApiDataApiItemById,
  downLoadFileByItemId,
  generateAppKeyInfo,
  applyAccount,
} from "@/api/dataServicesApi";
import { downloadFromBase64 } from "@/utils/date";
import ApplyForTestDialogVue from "../components/applyForTestDialog.vue";
import crypto from "@/utils/crypto";
export default {
  props: [],
  data() {
    return {
      apiName: "", //二级名称
      categoryName: "", //一级名称
      successRationStr: "",
      apiInfo: {},
      requestParamsData: [],
      // requestBody: {},
      applyDialogVisible: false,
      applyfortestForm: {
        appKey: "",
        secretKey: "",
        createTime: "",
        days: "",
        callCount: "",
      },
      apiApplyforTestList:[],
    };
  },
  components: {
    ApplyForTestDialogVue,
  },
  computed: {},
  watch: {},
  created() {
    this.getApiDataApiItemByIdList();
    this.successRationStr = this.$route.query.successRationStr; //成功率
  },
  mounted() {},
  methods: {
    // 点击加入购物车按钮 传递给父组件 不显示购物弹框
    isShowDrawerChange(){
      let arr =[
        {
          categoryApiId:this.apiInfo.apiDataCategoryId,
          apiId:this.apiInfo.apiDataApiId,
          // cartEnv:1 //环境目前1测试   生产环境待定
        }
      ]
      this.$emit('update-drawerStatus',false,arr)
    },
    // 加入/取消加入购物车
    isAddCartItemsClick(){
      let arr =[
        {
          categoryApiId:this.apiInfo.apiDataCategoryId,
          apiId:this.apiInfo.apiDataApiId,
          // cartEnv:1 //环境目前1测试   生产环境待定
        }
      ]
        // false：不显示购物车弹框, arr：传递的数据 ,this.apiInfo.cart：加入还是取消加入购物车的状态,2表示调二级的取消接口
       this.$emit("update-drawerStatus", false, arr,this.apiInfo.cart,2);
    },
    // 获取详情数据
    async getApiDataApiItemByIdList() {
      this.id = this.$route.query.id; //二级分类id
      this.categoryName = this.$route.query.categoryName;
      let res = await getApiDataApiItemById(`?id=${this.id}`);
      if (res.code == 200) {
        this.apiInfo = JSON.parse(JSON.stringify(res.data));
        this.apiName = this.apiInfo.apiName;
        this.categoryName = this.categoryName
          ? this.categoryName
          : this.apiInfo.apiDataCategoryName;
        this.requestParamsData = JSON.parse(this.apiInfo.requestParams);
        // this.requestBody =this.apiInfo.requestBody;
        console.log("this.apiInfo", this.apiInfo);
      } else {
        this.$message.error(res.msg);
      }
    },
    // 展示json对象
    formattedJson(data) {
      try {
        let obj = JSON.parse(data);
        return JSON.stringify(obj, null, 2); // 2 个空格缩进
      } catch (e) {
        return "Invalid JSON";
      }
    },
    // 下载
    downloadClick(type) {
      let params = {
        apiItemId: this.apiInfo.id,
        fileType: type,
      };
      if (type == "pdf") {
        downLoadFileByItemId(params).then((res) => {
          if (res.code == 200) {
            // 截取文件后缀名 查看属于什么文件
            let fileType = res.msg.split(".").pop().toLowerCase();
            var downloadType = "";
            if (fileType == "pdf") {
              downloadType = "application/pdf";
            }
            downloadFromBase64(res.data, downloadType, res.msg);
          } else {
            this.$message.error(res.msg);
          }
        });
      } else if (type == "word") {
        downLoadFileByItemId(params).then((res) => {
          if (res.code == 200) {
            // 截取文件后缀名 查看属于什么文件
            let fileType = res.msg.split(".").pop().toLowerCase();
            var downloadType = "";
            if (fileType == "docx") {
              downloadType =
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
            } else if (fileType == "doc") {
              downloadType = "application/msword";
            }
            downloadFromBase64(res.data, downloadType, res.msg);
          } else {
            this.$message.error(res.msg);
          }
        });
      } else if (type == "enum") {
        // 类型为enum 下载的文件类型可能是xls xlsx csv  doc pdf
        downLoadFileByItemId(params).then((res) => {
          if (res.code == 200) {
            // 截取文件后缀名 查看属于什么文件
            let fileType = res.msg.split(".").pop().toLowerCase();
            var downloadType = "";
            if (fileType == "pdf") {
              downloadType = "application/pdf";
            } else if (fileType == "docx") {
              downloadType =
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
            } else if (fileType == "doc") {
              downloadType = "application/msword";
            } else if (fileType == "xls") {
              downloadType = "application/vnd.ms-excel";
            } else if (fileType == "xlsx") {
              downloadType =
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
            } else if (fileType == "csv") {
              downloadType = "text/csv;charset=utf-8";
            }
            downloadFromBase64(res.data, downloadType, res.msg);
          } else {
            this.$message.error(res.msg);
          }
        });
      }
    },
    // 申请
    async applyforTest() {
      // 获取账号信息
      await generateAppKeyInfo().then((res) => {
        if (res.code == 200) {
          let generateAppKeyInfo = JSON.parse(JSON.stringify(res.data));
          // 解密密码
          generateAppKeyInfo.secretKey = crypto.decrypt(
            generateAppKeyInfo.secretKey
          );
          this.applyfortestForm = JSON.parse(
            JSON.stringify(generateAppKeyInfo)
          );
          this.getApiDataList(this.apiInfo)
          this.applyDialogVisible = true;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
     // 弹框需要的数据
    getApiDataList(row) {
      row.apiIdStr=this.id
      let applyArr = [
        {
          APIName: row.apiDataCategoryName,
          selectedChildren: JSON.parse(JSON.stringify([row])),
          // 给每个模块添加主题色(随机的)
          themeCssName: ["yellowTheme", "purpleTheme", "blueTheme"][
            (row.apiDataCategoryId - 1) % 3
          ],
        },
      ];
      //遍历 selectedChildren 数组，为每一项添加新属性
      applyArr[0].selectedChildren.forEach((item) => {
        item.days = this.applyfortestForm.days;
        item.callCount = this.applyfortestForm.callCount;
        item.applicationDate = this.applyfortestForm.createTime;
      });
      this.apiApplyforTestList = JSON.parse(JSON.stringify(applyArr));
    },
    // copy appkey secretKey
    async getAPPKey() {
      this.copyTool(this.applyfortestForm.appKey);
    },
    getSecretKey() {
      this.copyTool(this.applyfortestForm.secretKey);
    },
    async copyTool(data) {
      try {
        await this.$copyText(data);
        this.$message({
          message: "Copied",
          type: "success",
        });
      } catch (err) {
        this.$message({
          message: "Failed to copy: " + err,
          type: "warning",
        });
      }
    },
    closeApplyforTestVisible() {
      this.applyDialogVisible = false;
      this.applyfortestForm = {
        appKey: "",
        secretKey: "",
        createTime: "",
        days: "",
        callCount: "",
      };
    },
    // 生成(单一生成当前列数据的测试账号)
    async toGenerateClick() {
      try {
        let apiIdArr = [this.id];
        let params2 = {
          appKey: this.applyfortestForm.appKey,
          apiId: apiIdArr, //二级的分类id
          env: 1, //1是测试2是生产
        };
        let res2 = await applyAccount(params2);
        if (res2.code == 200) {
          if (res2.data.failApisNoRepeat && res2.data.failApisNoRepeat.length) {
            // 有重复的账号被申请
            this.$message.warning({
              dangerouslyUseHTMLString: true,
              message:
                "Some APIs have already been applied. Only unapplied APIs will be processed in batch.<br><br>This API has already been applied. Please do not repeat the operation.",
            });
          } else {
            this.$message.success(res2.msg);
            // 跳转到账号管理页面
            this.$router.push({ name: "AccountManagement" });
          }
        } else {
          this.$message.error(res2.msg);
        }
        this.closeApplyforTestVisible();
      } catch (error) {
        console.log("error", error);
      }
    },
  },
};
</script>

<style scoped>
/* 引入标签颜色样式 */
@import "../../../assets/css/DataLibraryIndexpage.css";
@import "../../../assets/css/DataApiDetail.css";
.APIHomepage_more_detail {
  position: relative;
}
.addcartBtn {
  margin-left: 16px;
  position: absolute;
  top: 10px;
  right: 0px;
  font-size:16px;
}
.APIHomepage_more_detail .more-info-block .info-title .width200 {
  display: inline-block;
  width: 200px;
  font-weight: bold;
}
/* 标签区域 */
.APIHomepage_more_detail .more-info-block .info-title .api-tag {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: 10px;
  flex-wrap: wrap;
}
.APIHomepage_more_detail .detail-breadcrumb .starStyle{
  vertical-align: middle;
    margin-left: 10px;
    cursor: pointer;
}
</style>
